// frontend\src\components\Navbar.js
import { useContext } from "react";
import { Link } from "react-router-dom";
import { APP_NAME } from "../constants";
import AuthContext from "../contexts/AuthContext";
import { useTheme } from "../contexts/ThemeContext";

import {
  BiUserCircle,
  BiLogOut,
  BiTachometer,
  BiLogIn,
  BiUserPlus,
  BiBook,
  BiCollection,
  BiFilm,
  BiStopwatch,
  BiCalculator,
  BiInfoCircle,
  BiSolidFlask,
} from "react-icons/bi";

// ThemeSwitcher теперь возвращает только кнопку, без li
const ThemeSwitcher = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      className="nav-link"
      onClick={toggleTheme}
      title={
        theme === "light"
          ? "Переключить на темную тему"
          : "Переключить на светлую тему"
      }
    >
      {theme === "light" ? (
        <i className="bi bi-moon-fill"></i>
      ) : (
        <i className="bi bi-sun-fill"></i>
      )}
    </button>
  );
};

// Компонент для переключения темы в dropdown
const ThemeSwitcherDropdownItem = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button className="dropdown-item" onClick={toggleTheme}>
      {theme === "light" ? (
        <>
          <i className="bi bi-moon-fill me-2"></i>
          Темная тема
        </>
      ) : (
        <>
          <i className="bi bi-sun-fill me-2"></i>
          Светлая тема
        </>
      )}
    </button>
  );
};

const Navbar = () => {
  const {
    isAuthenticated,
    username,
    first_name,
    last_name,
    isSuperuser,
    logoutUser,
  } = useContext(AuthContext);

  const displayName =
    first_name || last_name ? `${first_name} ${last_name}`.trim() : username;

  // Функция для закрытия навбара в мобильной версии
  const closeNavbar = () => {
    const navbarToggler = document.querySelector('.navbar-toggler');
    const navbarCollapse = document.querySelector('.navbar-collapse');
    
    if (navbarToggler && navbarCollapse && window.innerWidth < 992) {
      navbarToggler.setAttribute('aria-expanded', 'false');
      navbarCollapse.classList.remove('show');
    }
  };

  // Обработчик для ссылок - закрывает навбар
  const handleNavLinkClick = () => {
    closeNavbar();
  };

  // Обработчик для выхода - закрывает навбар и выполняет logout
  const handleLogout = () => {
    closeNavbar();
    logoutUser();
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container-fluid">
        <Link to="/" className="navbar-brand">
          {APP_NAME}
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          {/* Основное меню */}
          <ul className="navbar-nav me-auto">
            {isAuthenticated && (
              <>
                <li className="nav-item">
                  <Link to="/" className="nav-link" onClick={handleNavLinkClick}>
                    <BiBook className="me-1" />
                    База знаний
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/catalog" className="nav-link" onClick={handleNavLinkClick}>
                    <BiCollection className="me-1" />
                    Мой каталог
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/films" className="nav-link" onClick={handleNavLinkClick}>
                    <BiFilm className="me-1" />
                    Мои плёнки
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/chemicals" className="nav-link" onClick={handleNavLinkClick}>
                    <BiSolidFlask className="me-1" />
                    Мои химикаты
                  </Link>
                </li>
              </>
            )}
            <li className="nav-item">
              <Link to="/timer" className="nav-link" onClick={handleNavLinkClick}>
                <BiStopwatch className="me-1" />
                Таймер проявки
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/calc" className="nav-link" onClick={handleNavLinkClick}>
                <BiCalculator className="me-1" />
                Калькуляторы
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/about" className="nav-link" onClick={handleNavLinkClick}>
                <BiInfoCircle className="me-1" />
                О проекте
              </Link>
            </li>
          </ul>

          {/* Правая часть навбара */}
          <ul className="navbar-nav ms-auto text-center text-lg-start">
            {/* Переключатель темы только для десктопной версии */}
            <li className="nav-item d-none d-lg-block">
              <ThemeSwitcher />
            </li>

            {isAuthenticated ? (
              <li className="nav-item dropdown">
                <button
                  className="nav-link dropdown-toggle d-flex align-items-center justify-content-center justify-content-lg-start bg-transparent border-0 w-100"
                  id="userDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <BiUserCircle className="me-2" />
                  {displayName}
                </button>
                <ul className="dropdown-menu dropdown-menu-end text-center text-lg-start">
                  {isSuperuser && (
                    <li>
                      <Link
                        to="/admin/"
                        className="dropdown-item"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={handleNavLinkClick}
                      >
                        <BiTachometer className="me-1" />
                        Администрирование
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link to="/profile" className="dropdown-item" onClick={handleNavLinkClick}>
                      <i className="bi bi-person me-2"></i>
                      Профиль
                    </Link>
                  </li>
                  {/* Переключатель темы для мобильной версии */}
                  <li className="d-lg-none">
                    <ThemeSwitcherDropdownItem />
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <button className="dropdown-item" onClick={handleLogout}>
                      <BiLogOut className="me-1" />
                      Выйти
                    </button>
                  </li>
                </ul>
              </li>
            ) : (
              <>
                <li className="nav-item">
                  <Link 
                    to="/login" 
                    className="nav-link d-flex align-items-center" 
                    title="Войти"
                    onClick={handleNavLinkClick}  // Добавьте это
                  >
                    <BiLogIn className="me-2" />
                    <span className="d-none d-lg-inline">Войти</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link 
                    to="/register" 
                    className="nav-link d-flex align-items-center" 
                    title="Зарегистрироваться"
                    onClick={handleNavLinkClick}  // Добавьте это
                  >
                    <BiUserPlus className="me-2" />
                    <span className="d-none d-lg-inline">Регистрация</span>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;